(() => {
  const initializeStickyAtc = (root = document) => {
    const bars = root.querySelectorAll ? root.querySelectorAll('[data-bl-sticky-atc]') : [];

    bars.forEach((bar) => {
      if (bar.dataset.blStickyInitialized === 'true') return;

      const mainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!mainButton) return;

      bar.dataset.blStickyInitialized = 'true';

      const observer = new IntersectionObserver(
        ([entry]) => {
          const shouldShow = !entry.isIntersecting && window.scrollY > 160;
          bar.classList.toggle('is-visible', shouldShow);
        },
        { threshold: 0.2 }
      );

      observer.observe(mainButton);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeStickyAtc());
  } else {
    initializeStickyAtc();
  }

  document.addEventListener('shopify:section:load', (event) => initializeStickyAtc(event.target));

  const productObserver = new MutationObserver(() => initializeStickyAtc());
  productObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
